module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesLuxury@2x.3407605.jpg";